module.exports = __webpack_public_path__ + "img/engineer-logo-1-active.31a1a114.png";